import styled from 'styled-components'

export const ImagesContainer = styled.div`
  display: grid;
  flex-direction: column;
  gap: 10px;
  grid-template-columns: repeat(2, 1fr);
  max-width: 100%;
  gap: 1rem;
  margin-top: 1rem;
`

export const RemoveImage = styled.button`
  background-color: #FD7477;
  border: none;
  color: white;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 50%;
  z-index: 1;
`

export const DragHandle = styled.button`
  position: absolute;
  top: 10px;
  left: 2.5rem;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: #fff;
  border-radius: 0.4rem;
  padding: 4px;
  cursor: grab;
  color: #6b7280;

  &:active {
    cursor: grabbing;
  }
`

export const ImageOrderBadge = styled.span`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
  min-width: 1.75rem;
  height: 1.75rem;
  padding: 0 0.35rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #374151;
  font-size: 0.875rem;
  font-weight: 700;
`

export const ImageContainer = styled.div<{ $isDragging?: boolean }>`
  width: 100%;
  position: relative;
  padding: 1rem;
  border: 1px solid ${({ $isDragging }) => ($isDragging ? '#0090D3' : '#d1d5db')};
  border-radius: 1rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  transition: box-shadow 0.2s ease-in-out;
  background: #fff;
  box-shadow: ${({ $isDragging }) =>
    $isDragging ? '0 8px 16px -4px rgba(0, 144, 211, 0.25)' : 'none'};

  &:hover {
    box-shadow: ${({ $isDragging }) =>
      $isDragging ? '0 8px 16px -4px rgba(0, 144, 211, 0.25)' : '0 4px 2px -2px #d1d5db'};
  }
`

export const Image = styled.img`
  width: 100%;
  height: 15rem;
  border-radius: 1rem;
  object-fit: cover;
  background-color: #F4F4F4;
`

export const ImageInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #6B7280;
  font-weight: 500;
`

export const EditInfosAbout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: #6B7280;
  font-weight: 500;
`

export const TitleOrSubtitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  border: 1px solid #d1d5db;
  padding: 0.5rem;
  border-radius: 0.4rem;
  transition: all 0.2s ease-in-out;
  cursor: text;
  
  svg {
    display: none;
  }

  &:hover {
    border-color: #6b7280;
    svg {
      display: block;
    }
  }
`

export const TitleOrSubtitleInput = styled.input`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  border: 1px solid #d1d5db;
  padding: 0.5rem;
  border-radius: 0.4rem;
  outline: none;
  transition: all 0.1s ease-in-out;
  
  &:focus {
    border: 1px solid #0090D3;
  }
`
